export function getChangeRequestsEndpoint(): string {
    return '/changesOverview';
}
